/**
 * OOO LP — Calm Hero page interactions.
 * Loaded deferred from ooo-lp-calm-content.liquid.
 *
 * Handles:
 *   1. Offer gallery — thumbnail → main image swap
 *   2. Offer plan toggle — subscribe / one-time radio options
 *   3. Add-to-cart form — delegates to window.OOOCart (defined in ooo-cart.js)
 */

(function () {
  'use strict';

  // Guard: run after DOM is ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    initGallery();
    initPlanToggle();
    initAtcForm();
  });

  /* ── 1. Offer gallery ──────────────────────────────────────── */
  function initGallery() {
    var strip = document.querySelector('.ooo-lp-offer__thumbs');
    if (!strip) return;

    var main = document.getElementById('ooo-offer-main');
    var thumbs = strip.querySelectorAll('.ooo-lp-offer__thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (!img || !main) return;

        // Fade out / swap / fade in
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = img.src;
          main.style.opacity = '1';
        }, 150);

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── 2. Plan toggle (subscribe / one-time) ─────────────────── */
  function initPlanToggle() {
    var groups = document.querySelectorAll('[data-ooo-plan-opts]');

    groups.forEach(function (group) {
      var opts = group.querySelectorAll('[data-ooo-plan-opt]');

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) {
            o.classList.remove('is-active');
            var radio = o.querySelector('input[type="radio"]');
            if (radio) radio.checked = false;
          });
          opt.classList.add('is-active');
          var radio = opt.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
        });
      });
    });
  }

  /* ── 3. Add-to-cart — hook into ooo-cart.js AJAX ──────────── */
  function initAtcForm() {
    var form = document.getElementById('ooo-lp-atc-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value.trim() : '';

      // No variant configured — open empty cart gracefully (empty store)
      if (!variantId) {
        if (window.OOOCart && typeof window.OOOCart.open === 'function') {
          window.OOOCart.open();
        }
        return;
      }

      // Delegate to ooo-cart.js AJAX add
      var qty = form.querySelector('[name="quantity"]');
      var data = {
        id: variantId,
        quantity: qty ? parseInt(qty.value, 10) || 1 : 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [data] })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add failed');
        return res.json();
      })
      .then(function () {
        // Refresh and open the side cart
        if (window.OOOCart && typeof window.OOOCart.refresh === 'function') {
          window.OOOCart.refresh();
        } else if (window.OOOCart && typeof window.OOOCart.open === 'function') {
          window.OOOCart.open();
        }
      })
      .catch(function () {
        // Fallback: open cart anyway
        if (window.OOOCart && typeof window.OOOCart.open === 'function') {
          window.OOOCart.open();
        }
      });
    });
  }

})();
